module.exports = __webpack_public_path__ + "static/img/homepage-bg.b15e436.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/homepage-bg.png
// module id = 2IDL
// module chunks = 1